import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class WarningModal extends React.Component {
  static propTypes = {
    errorMessage: PropTypes.object,
    hideModal: PropTypes.func
  }
  componentDidMount() {}
  render() {
    const { errorMessage } = this.props
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        onOk={this.handleDelete}
        maxWidth={'xs'}
        title={`Oups... une erreur est survenue`}
        cancelText="Fermer"
        showOk={false}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              {errorMessage}
            </Typography>
            <Typography variant="body1" gutterBottom>
              Veuillez utiliser le chat en bas à droite pour entrer en contact
              avec le support
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(WarningModal)



// WEBPACK FOOTER //
// ./src/components/modals/common/ChatHelpModal.js